
import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { CustomCol, CustomCard } from 'src/components'
import AdminCardButtons from './AdminCardButtons/AdminCardButtons'
import { leftButtons, rigthButtons } from './admin-actions.buttons'
import SupppliersInfoAPIButton from './SupppliersInfoAPIButton/SupppliersInfoAPIButton'

const UserAdminActions: React.FC = () => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <Row className='mt-4'>
    <CustomCol>
      <CustomCard cardTitle={t('admin.CtActions')}>
        <AdminCardButtons buttons={leftButtons(t)} />
      </CustomCard>

    </CustomCol>
    <CustomCol className={isMobile && 'mt-4'}>
      <CustomCard cardTitle={t('admin.ValidationFeatures')}>
        <AdminCardButtons buttons={rigthButtons(t)} />
        <SupppliersInfoAPIButton />
      </CustomCard>
    </CustomCol>
  </Row>
}

export default UserAdminActions
